const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/private/dashboard/Index.vue')
const General = () => import(/* webpackChunkName: "dashboard" */ '@/components/dashboard/Index.vue')
const POS = () => import(/* webpackChunkName: "dashboard" */ '@/components/dashboard/Pos.vue')

const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {
      title: "Beranda"
    },
    children: [
      {
        path: '/dashboard/general',
        name: 'dashboard',
        component: General,
        meta: {
          title: "Beranda"
        }
      },
      {
        path: '/dashboard/pos',
        name: 'dashboard',
        component: POS,
        meta: {
          title: "Beranda POS"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})